export default {
  code: 'fr',
  messages: {
    'address': `L'adresse n'est pas entièrement complété`,
    'complaint-number-file': 'Le champ est invalide',
    'national-id': 'Le champ est invalide',
    'yes-no-maybe-selector-required': `Le champ est obligatoire`,
  },
};
